export const freeTrialTCMatch = '/terms-and-conditions'
export const papersMatch = '/papers*'
export const plansMatch = '/plans'
export const rootMatch = '/'
export const wildcardMatch = '*'
export const workspaceMatch = '/edit/:id'
export const demoWorkspaceMatch = '/demo*'

export function getWorkspacePath(id: string, isDemo = false): string {
  return isDemo ? '/demo' : `/edit/${id}`
}
export function getGrammarWorkspacePath(id: string, isDemo = false): string {
  return isDemo ? '/demo' : `/edit/${id}`
}
export function getPlagiarismWorkspacePath(id: string, isDemo = false): string {
  return isDemo ? '/demo/plagiarism' : `/edit/${id}/plagiarism`
}
export function getExpertCheckWorkspacePath(
  id: string,
  slug: string = '',
  isDemo = false
): string {
  if (isDemo) {
    return `/demo/expert-check`
  }

  if (slug) {
    return `/edit/${id}/expert-check/${slug}`
  }
  return `/edit/${id}/expert-check`
}

export const rootPathRegex = /^\/$/
export const editorGrammarPathRegex = /^\/edit\//
export const editorPlagiarismPathRegex = /plagiarism\/?$/
export const expertCheckRegex = /expert-check\/?/
export const expertCheckFormRegex = /expert-check\/?$/
export const expertCheckSuccessRegex = /expert-check\/success\/?$/
export const expertCheckInProgressRegex = /expert-check\/in-progress\/?$/
export const expertCheckCompleteRegex = /expert-check\/complete\/?$/
export const expertCheckUpgradeRegex = /expert-check\/upgrade\/?$/
export const termsAndConditionsRegex = new RegExp(freeTrialTCMatch)
export const plansPageRegex = /plans\/?$/

export const isDemoPage = (pathname: string): boolean => /\/demo/.test(pathname)

export const isWorkspacePage = (pathname: string): boolean =>
  !!pathname.match(/\/edit\/*/)

export const isExpertCheckPage = (pathname: string) => expertCheckRegex.test(pathname)

export const isRootPage = (pathname: string) => rootPathRegex.test(pathname)

export const isGrammarPage = (pathname: string) => editorGrammarPathRegex.test(pathname)

export const isPlagiarismPage = (pathname: string) =>
  editorPlagiarismPathRegex.test(pathname)

export const isECFormPage = (pathname: string) => expertCheckFormRegex.test(pathname)

export const isECUpgradePage = (pathname: string) =>
  expertCheckUpgradeRegex.test(pathname)

export const isECSuccessPage = (pathname: string) =>
  expertCheckSuccessRegex.test(pathname)

export const isECInProgressPage = (pathname: string) =>
  expertCheckInProgressRegex.test(pathname)

export const isECCompletePage = (pathname: string) =>
  expertCheckCompleteRegex.test(pathname)

export const isTCPage = (pathname: string) => termsAndConditionsRegex.test(pathname)

export const isPlansPage = (pathname: string) => plansPageRegex.test(pathname)



// WEBPACK FOOTER //
// ./src/utils/routes.ts